import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import MenuIcon from "@mui/icons-material/Menu";
import { dot, vosmosLogo1, vosmosLogo2 } from "../assets/img";
import { useDispatch, useSelector } from "react-redux";
import ProgressiveImage from "rc-progressive-image";
import { Avatar, Box, Button, Fab, ListItemIcon } from "@mui/material";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { logoutUser } from "../store/action";
import PersonIcon from "@mui/icons-material/Person";
import LogoutIcon from "@mui/icons-material/Logout";
import { useApi } from "../hooks";
import { apiLogutUser, method } from "../apiPath";
import { getToast } from "../common/utils";
import keyNames from "../keyName";

const toast = getToast("error");
const Header = ({ open, setOpen }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const storeData = useSelector((state) => state.mainReducer);
  const { themeMode } = storeData;

  const hitApi = useApi();
  const [anchorEl, setAnchorEl] = useState(null);
  const show = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (path) => {
    if(path)navigate(path)
    setAnchorEl(null);
  };
  const logOut = () => {
    hitApi(apiLogutUser, null, method.post, keyNames.userData, toast);
  };

  return (
    <AppBar position="fixed" color="transparent" elevation={0}>
      <Toolbar
        sx={{ paddingLeft: "16px !important", paddingRight: "16px !important" }}
      >
        <Button
          variant=""
          sx={{
            mr: 2,
            p: 0.7,
            minWidth: "auto",
          }}
          onClick={() => setOpen(!open)}
        >
          <MenuIcon />
        </Button>
        <Box sx={{ flexGrow: 1 }}>
          <Box className="logo">
            <Link to="/app">
              <ProgressiveImage
                src={themeMode === "light" ? vosmosLogo1 : vosmosLogo2}
                placeholder={dot}
                errorImage={dot}
                alt="Vosmos Forms"
              />
            </Link>
          </Box>
        </Box>

        <Fab
          size="small"
          color="primary"
          aria-label="profile"
          onClick={handleClick}
        >
          <AccountCircle />
        </Fab>

        <Menu
          id="menu-appbar"
          anchorEl={anchorEl}
          open={show}
          onClose={()=>handleClose()}
          sx={{ mt: 1.5 }}
          MenuListProps={{ sx: { minWidth: 150 } }}
        >
          <MenuItem sx={{ py: 1.5 }} onClick={()=>handleClose("user-profile")}>
            <ListItemIcon>
              <PersonIcon />
            </ListItemIcon>
            Profile
          </MenuItem>
          <MenuItem sx={{ py: 1.5 }} onClick={logOut}>
            <ListItemIcon>
              <LogoutIcon />
            </ListItemIcon>
            Logout
          </MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
